export default "__VITE_ASSET__C9513mnE__"